import {
  APICallState,
  Selectors,
  useIsDesktop,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useDispatch, useSelector} from 'Provider';
import React from 'react';

import CompanionSummary from 'components/CompanionSummary';
import {
  updateCompanionNumberStateSelector,
  updatedUserInfoCompanionIdSelector,
} from 'store/profile';
import {ProfileActions} from 'store/profile/profile.reducer';
import MFAGate from 'containers/MFAGate';
import {profileTabForwardUrl} from 'models/MFA';
import GatedCompanionSummaryModule from 'components/GatedProfilePanels/GatedCompanionSummaryModule';

const ConnectedCompanionSummary = () => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const companionNumber = useWidgetState(Selectors.companionIdSelector) as
    | string
    | undefined;
  const updateCompanionNumberState = useSelector(
    updateCompanionNumberStateSelector
  );

  // When we do an update, save it with in our app's store and use it instead.
  const updatedCompanionNumber = useSelector(
    updatedUserInfoCompanionIdSelector
  );

  const handleOnSavePressed = (newCompanionNumber: string) => {
    dispatch(ProfileActions.updateCompanionNumber(newCompanionNumber));
  };

  const restProfileState = () =>
    dispatch(ProfileActions.resetCompanionNumberState());

  const getGuestProfileCallState = useWidgetState(
    Selectors.getGuestProfileCallStateSelector
  ) as APICallState;

  return (
    <MFAGate
      forwardUrl={profileTabForwardUrl}
      GatedComponent={GatedCompanionSummaryModule}
      forceLoading={getGuestProfileCallState !== APICallState.SUCCESS}>
      <CompanionSummary
        companionNumber={updatedCompanionNumber || companionNumber}
        onSavePressed={handleOnSavePressed}
        apiCallState={updateCompanionNumberState}
        resetAPICallState={restProfileState}
      />
    </MFAGate>
  );
};

export default ConnectedCompanionSummary;
